var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10a3.332 3.332 0 100-6.667 3.332 3.332 0 00-3.333 3.334A3.332 3.332 0 0010 10zm0 1.667c-2.225 0-6.667 1.116-6.667 3.333v1.667h13.334V15c0-2.217-4.442-3.333-6.667-3.333z",
    fill: "#006DFF"
  })));
}
export default SvgFullProfile;